
<PickupAdShowList :is-loading="isLoading" :pickup-ads="releasedPickupAds" @read="handleRead" />
